module.exports = __webpack_public_path__ + "static/media/31706521_1276149969189089_1597541234962857984_o.ce10b3d7.jpg";